import moment from 'moment-timezone';
import 'moment-duration-format';
import { formatNumber } from './helpers';

export class FilterRanges {
  static setT(t){
    this.t = t
  }

  static getT(){
    return this.t;
  }

  static getDurationRange(range) {
    const t = FilterRanges.getT()
    return {
      from: moment.duration(range[0], 'minutes').format(`h [${t('dashboard:hours')}] m [${t('dashboard:min')}]`),
      to: moment.duration(range[1], 'minutes').format(`h [${t('dashboard:hours')}] m [${t('dashboard:min')}]`),
    };
  }

  static getTimeRange(range) {
    const t = FilterRanges.getT()
    return {
      from: `${formatNumber(Math.floor(range[0] / 60), 2)}:${formatNumber(
        range[0] - Math.floor(range[0] / 60) * 60,
        2,
      )}`,
      to: `${formatNumber(Math.floor(range[1] / 60), 2)}:${formatNumber(
        range[1] - Math.floor(range[1] / 60) * 60,
        2,
      )}`,
    };
  }

  static getDistanceRange(range) {
    console.log('-')
    const t = FilterRanges.getT()
    console.log(t)    
    return {
      from: range[0],
      to: `${range[1]} ${t('dashboard:km')}`,
    };
  }
}



// WEBPACK FOOTER //
// ./src/utils/filterRanges.js